import { FC, useState, useEffect } from 'react';
import InputLabel from 'raydiant-elements/core/InputLabel';
import InputHelperText from 'raydiant-elements/core/InputHelperText';
import Input from 'raydiant-elements/core/Input';
import Text from 'raydiant-elements/core/Text';
import { PresentationProperty } from '@raydiant/api-client-js';
import { getPropertyMin, setPropertyMin } from '../../utilities/properties';
import { useApplicationFormContext } from '../../hooks/useApplicationForm';

interface ApplicationInputMinNumberProps {}

const getMinValueFromProperty = (property: PresentationProperty | null) => {
  if (!property) return '';
  if (typeof getPropertyMin(property) !== 'number') return '';
  return String(getPropertyMin(property));
};

const ApplicationInputMinNumber: FC<ApplicationInputMinNumberProps> = () => {
  const {
    isEditable,
    version,
    selectedProperty,
    updateSelectedProperty,
  } = useApplicationFormContext();

  // State

  const [min, setMin] = useState(getMinValueFromProperty(selectedProperty));

  // Callbacks

  const handleBlur = () => {
    if (!selectedProperty) return;
    if (!version) return;

    const minNumber = parseInt(min, 10);
    updateSelectedProperty(
      setPropertyMin(selectedProperty, isNaN(minNumber) ? null : minNumber),
      version.strings,
    );
  };

  // Effects

  // Reset min value when property changes.
  useEffect(() => {
    setMin(getMinValueFromProperty(selectedProperty));
  }, [selectedProperty]);

  // Render

  return (
    <div>
      <InputLabel>Min Value</InputLabel>

      {isEditable && (
        <>
          <div style={{ maxWidth: 120 }}>
            <Input
              type="number"
              value={min}
              onChange={setMin}
              onBlur={handleBlur}
            />
          </div>
          <InputHelperText>
            The minimum number allowed for this input.
          </InputHelperText>
        </>
      )}

      {!isEditable && selectedProperty && (
        <Text>{getPropertyMin(selectedProperty) ?? <em>None</em>}</Text>
      )}
    </div>
  );
};

export default ApplicationInputMinNumber;
